import React from 'react';
import {
  Box, Button, Popover, PopoverBody, PopoverCloseButton,
  PopoverContent, PopoverTrigger, Portal, VStack, HStack,
  FormControl, PopoverHeader, Text, Input, Switch,
} from '@chakra-ui/react';
import { useForm, Controller } from 'react-hook-form';
import { BoxTitle } from '@/components/BoxTitle';
import { FiEdit3 } from 'react-icons/fi';
import { FieldTipoEndereco } from '@/components/Fields/TipoEndereco';
import ActiveSwitch from '@/components/components/ActiveSwitch';

interface FilterData {
  rua?: string;
  predio?: string;
  andar?: string;
  apartamento?: string;
  tipo?: string;
  ativo?: boolean;
}

interface FielterProps {
  children: React.ReactNode;
  onFilter: (data: Partial<FilterData>) => void;
}

function Fielter({ children, onFilter }: FielterProps) {
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    getValues,
    control
  } = useForm<FilterData>({
    defaultValues: {
      rua: '',
      predio: '',
      andar: '',
      apartamento: '',
      tipo: '',
      ativo: true
    }
  });

  const onSubmit = (data: FilterData) => {
    onFilter(data);
  };

  const handleCancel = () => {
    reset({
      rua: '',
      predio: '',
      andar: '',
      apartamento: '',
      tipo: '',
      ativo: true
    });
  };

  return (
    <Popover placement="auto-start" closeOnBlur={false} closeOnEsc={false}>
      <PopoverTrigger>
        <Box textAlign="center">{children}</Box>
      </PopoverTrigger>
      <Portal>
        <PopoverContent w="500px" borderTopRightRadius="3xl">
          <PopoverCloseButton color="white" p="1" />
          <PopoverHeader bg="#117baa" color="white" borderTopRightRadius="3xl" m={0} p={1} fontSize="15px">
            <HStack>
              <Box as={FiEdit3} color="#117baa" boxSize={7} p={1} bg="#DBF2FB" rounded="full" />
              <Text fontSize="15px" color="white">Filtro</Text>
            </HStack>
          </PopoverHeader>

          <PopoverBody p={4}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <VStack spacing={4} align="stretch">
                <HStack spacing={4}>
                  <FormControl>
                    <BoxTitle title="Rua">
                      <Input {...register('rua')} />
                    </BoxTitle>
                  </FormControl>

                  <FormControl>
                    <BoxTitle title="Prédio">
                      <Input {...register('predio')} />
                    </BoxTitle>
                  </FormControl>
                </HStack>

                <HStack spacing={4}>
                  <FormControl>
                    <BoxTitle title="Andar">
                      <Input {...register('andar')} />
                    </BoxTitle>
                  </FormControl>

                  <FormControl>
                    <BoxTitle title="Apto">
                      <Input {...register('apartamento')} />
                    </BoxTitle>
                  </FormControl>
                </HStack>

                <HStack spacing={4}>
                  <FormControl>
                    <BoxTitle title="Tipo">
                      <FieldTipoEndereco
                        title={false}
                        isInvalid={false}
                        // @ts-ignore
                        value={watch('tipo')}
                        onChange={(val) => setValue('tipo', val)}
                      />
                    </BoxTitle>
                  </FormControl>

                  <FormControl display="flex" alignItems="center">
                    <ActiveSwitch
                      size="sm"
                      isChecked={watch("ativo")}
                      onChange={(checked: any) => setValue("ativo", checked)}
                    />
                  </FormControl>
                </HStack>

                <HStack justify="flex-end" w="100%">
                  <Button size="sm" type="submit" colorScheme="blue">Filtrar</Button>
                  <Button size="sm" type="button" colorScheme="red" onClick={handleCancel}>Limpar</Button>
                </HStack>
              </VStack>
            </form>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}


export default Fielter;
